<template>
  <div
    id="right-srcoll"
    class="properties-body beauty-scroll"
  >
    <!-- 普通文件的右侧详情 -->
    <div v-ie-placeholder>
      <ul>
        <li>
          <span
            class="property-title"
            style="display:inline-block"
          >{{ $t('路径') }}</span>
          <div class="edit-btns">
            <el-tooltip
              effect="dark"
              :content="$t('复制')"
              placement="top"
            >
              <svg
                class="item-icon"
                @click="copyRoute"
              >
                <use xlink:href="#copy" />
              </svg>
            </el-tooltip>
          </div>
          <span class="property-content">{{ selectedData.path }}</span>
        </li>
        <li>
          <span class="property-title">{{ $t('更新时间') }}</span>
          <span class="property-content">
            {{ Util.formatDate(selectedData.modified, 'yyyy-MM-dd hh:mm') }}
          </span>
        </li>
        <li>
          <span class="property-title">{{ $t('本地修改时间') }}</span>
          <span class="property-content">
            {{ selectedData && selectedData.localModifyTime? Util.formatDate(selectedData.localModifyTime, 'yyyy-MM-dd hh:mm') : '' }}
          </span>
        </li>
        <li>
          <span class="property-title">{{ $t('创建者') }}</span>
          <span class="property-content">{{ selectedData.creator }}</span>
        </li>
        <li v-if="secretSwitch">
          <span class="property-title">{{ $t('文件密级') }}</span>
          <span class="property-content">
            {{ selectedData.security_file_name }}
          </span>

        <!-- </li>
        <li v-if="!noDynamic">
            <span
              class="property-title"
              style="display:inline-block"
            >{{ $t('引用地址') }}</span>
            <div class="edit-btns">
              <el-tooltip
                effect="dark"
                :content="$t('复制')"
                placement="top"
              >
                <svg
                  class="item-icon copyAddress"
                  @click="copyAddress"
                >
                  <use xlink:href="#copy" />
                </svg>
              </el-tooltip>
            </div>
          </li> -->

        <li>
          <span
            class="property-title"
            style="display:inline-block"
          >{{ $t('备注') }}</span>
          <div class="edit-btns">
            <el-tooltip
              effect="dark"
              :content="$t('编辑')"
              placement="top"
            >
              <svg
                class="item-icon"
                @mousedown="showCommentCommit"
              >
                <use xlink:href="#edit" />
              </svg>
            </el-tooltip>
          </div>
        </li>
      </ul>
      <el-input
        v-if="showRemarkInput"
        ref="remarkInput"
        v-model="remarkData"
        type="textarea"
        autosize
        maxlength="100"
        resize="none"
        rows="1"
        :placeholder="$t('输入备注文字，最多100个字符')"
        @blur="commitSave"
      >
      </el-input>
      <div
        v-else
        class="remarks-text"
      >{{ remarkData }}</div>
    </div>
  </div>
  </div>
</template>

<script>
import * as Util from 'js/util/util'
import store from 'store'
import FileUrlReferenceClipboard from 'js/util/fileUrlReferenceClipboard'
import { setClipboard } from '@filez/js-2-native'
import _$ from 'js/api/getdata'
const { postData } = require('js/api/getdata').default

export default {
  components: {
  },
  data() {
    return {
      Util,
      data: {},
      remarkData: '',
      lowBDialog: false,
      copyText: '',
      showRemarkInput: false,
      notHideInput: false,
      secretSwitch: false,
    }
  },
  computed: {
    /**
     * 当前选中的数据，替换原view代码 value 为selectedData
     */
    selectedData() {
      return store.state.curFileInfo
    },
    noDynamic() {
      const pathType = this.$store.state.curFileInfo.path_type
      return pathType === 'self' || pathType === 'share_in' || pathType === 'share_out'
    },
  },
  watch: {
    selectedData() {
      this.remarkData = this.selectedData.desc
      this.showRemarkInput = false
    },
  },
  mounted() {
    this.remarkData = this.remarksData || this.selectedData.desc
    const currentData = this.$route.params
    if(!this.noDynamic) {
      store.dispatch('getFileReferenceUrl', currentData)
    }
    this.getSecretSwitch()
  },
  methods: {
    getSecretSwitch() {
      _$.getData('getSecretSwitch').then((res) => {
        this.secretSwitch = res.data.security_classification_switch === '1'
      })
    },
    showCommentCommit() {
      if (this.showRemarkInput) {
        this.notHideInput = true
      }
      this.showRemarkInput = true
      this.$nextTick(() => {
        this.$refs.remarkInput.focus()
        const ele = document.getElementById('right-srcoll')
        if (ele.scrollHeight > ele.clientHeight) {
          ele.scrollTop = ele.scrollHeight
        }
      })
    },
    commitCancle() {
      this.closeCommentCommit()
    },
    commitSave() {
      if (this.notHideInput) {
        this.notHideInput = false
        return
      }
      this.$refs.remarkInput.focus()
      if (this.remarkData == this.selectedData.desc) {
        this.showRemarkInput = false
        return
      }
      const data = {
        neid: this.selectedData.neid,
        field: 'desc',
        desc: this.remarkData,
      }
      postData('commitSave', data, { url: this.selectedData.path }).then(() => {
        this.showRemarkInput = false
        this.$store.commit('GET_TOAST_INFO', this.$t('成功'))
        this.updateSelectedData()
      }).catch((error) => {
        const err = error.response.data
        this.$store.commit('GET_TOAST_INFO', { info: err.message, tipsType: 'error' })
      })
    },
    copyRoute() {
      // 创建文本元素
      const textArea = document.createElement('textArea')
      textArea.value = this.selectedData.path
      document.body.appendChild(textArea)

      textArea.select()
      if (document.execCommand('copy')) {
        this.$store.commit('GET_TOAST_INFO', this.$t('路径已成功复制到剪贴板中'))
      } else {
        this.copyText = this.selectedData.path
        this.lowBDialog = true
      }
      document.body.removeChild(textArea)
    },
    copyAddress() {
      new FileUrlReferenceClipboard({
          context: this,
          className: '.copyAddress',
          text: store.state.fileUrlReferenceState.url,
          onSuccessCallback: () => {
            this.$store.commit('GET_TOAST_INFO',this.$t('复制成功'))
          },
        })
        const clientObj = {
          text: store.state.fileUrlReferenceState.url,
        }
        if(Util.isClient()) {
          setClipboard(clientObj)
        }
        const { neid, nsid } = this.$store.state.curFileInfo
        postData('createFileRefShortUrl', {
          neid,
          nsid,
          logack: true,
        })
    },
    updateSelectedData() {
      const data = this.selectedData
      data.desc = this.remarkData
      // store.commit('updateSelectedData', data);
    },
  },
}
</script>

<style lang="less" scoped>
  .properties-body {
    padding: 0px 24px;
    height: 100%;
    user-select: text;
    ul {
        margin: 0;
        margin-top: 20px;
        width: 250px;
        list-style: none;
        color: #637282;
        li {
            line-height: 20px;
            margin-bottom: 28px;
            position: relative;
            span {
                display: block;
            }
            .property-content {
                margin-top: 8px;
                word-break: break-all;
                max-width: 250px;
                &.summary span{
                    display: inline-block;
                }
                &.copy {
                    user-select: text;
                    cursor: text;
                }
                .get-summary {
                    cursor: pointer;
                    text-decoration: underline;
                }
            }
            .property-link {
                display: inline-block;
                margin-left: 12px;
                cursor: pointer;
                color: rgb(10, 100, 250);
            }
            /deep/ .el-textarea {
                margin-top: 8px;
            }
        }
        li:last-child {
            margin-bottom: 8px;
        }
        li.summary {
            /deep/ .el-textarea {
                margin-top: 8px;
            }
            .remarks-text {
                margin-top: 8px;
                padding-bottom: 0;
            }
        }
    }
    .edit-btns {
        display: inline-block;
        margin-left: 20px;
        position: absolute;
        &.show-edit{
            position: absolute;
            top: 0;
            right: 286px;
        }
        .item-icon {
            width: 20px;
            height: 20px;
            margin-top: -2px;
            padding: 2px;
            border-radius: 2px;
            cursor: pointer;
            &:hover {
                background-color: #e8ebef;
            }
        }
    }
    .remarks-text {
        padding-top: 8px;
        max-width: 250px;
        line-height: 15px;
        padding-bottom: 10px;
        color: #545454;
        word-break: break-all;
        white-space: pre-wrap;
    }
  }
</style>
